 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"aboutUs":"aboutUs","analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7":"analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7","analytics":"analytics","angwalangkwentangpodcast":"angwalangkwentangpodcast","apiandintegrations":"apiandintegrations","articles":"articles","automatednotif":"automatednotif","careers":"careers","chef-gordon-ramsay-in-manila":"chef-gordon-ramsay-in-manila","dfesta":"dfesta","helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers":"helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers","helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success":"helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success","incomecalculator~spart":"incomecalculator~spart","incomecalculator":"incomecalculator","spart":"spart","pricing":"pricing","recurringpayments":"recurringpayments","revolutionizes-online-booking-for-visayas-largest-water-parks":"revolutionizes-online-booking-for-visayas-largest-water-parks","storefronts":"storefronts","surgeError":"surgeError","ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events":"ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events","up-sports-ticketing":"up-sports-ticketing","creators~ecommerce~services":"creators~ecommerce~services","creators":"creators","ecommerce":"ecommerce","services":"services","insights":"insights","privacyPolicy":"privacyPolicy","saas":"saas","termsAndConditions":"termsAndConditions","ticketing":"ticketing"}[chunkId]||chunkId) + "." + {"aboutUs":"f1fda60a","analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7":"be6b79b6","analytics":"d015a79f","angwalangkwentangpodcast":"43ecc8e2","apiandintegrations":"df03d293","articles":"5d2da12a","automatednotif":"d899975f","careers":"7072deb1","chef-gordon-ramsay-in-manila":"e6fb1251","dfesta":"d36d4d8c","helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers":"9fa9f3ec","helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success":"18f76867","incomecalculator~spart":"54b8a96d","incomecalculator":"f05e7371","spart":"cf25c2d7","pricing":"06fa1872","recurringpayments":"036552a1","revolutionizes-online-booking-for-visayas-largest-water-parks":"d35b7bac","storefronts":"00ced6a5","surgeError":"fda62cbd","ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events":"fe893acb","up-sports-ticketing":"4fbf5965","creators~ecommerce~services":"0de17a95","creators":"eec0ce9f","ecommerce":"b07c8672","services":"e76313f6","insights":"db910996","privacyPolicy":"b4ee9213","saas":"3dbbb5dc","termsAndConditions":"61bb4fc8","ticketing":"b7921175"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"aboutUs":1,"analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7":1,"analytics":1,"angwalangkwentangpodcast":1,"apiandintegrations":1,"articles":1,"automatednotif":1,"careers":1,"chef-gordon-ramsay-in-manila":1,"dfesta":1,"helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers":1,"helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success":1,"incomecalculator~spart":1,"incomecalculator":1,"spart":1,"pricing":1,"recurringpayments":1,"revolutionizes-online-booking-for-visayas-largest-water-parks":1,"storefronts":1,"surgeError":1,"ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events":1,"up-sports-ticketing":1,"creators~ecommerce~services":1,"creators":1,"ecommerce":1,"services":1,"insights":1,"privacyPolicy":1,"saas":1,"termsAndConditions":1,"ticketing":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"aboutUs":"aboutUs","analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7":"analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7","analytics":"analytics","angwalangkwentangpodcast":"angwalangkwentangpodcast","apiandintegrations":"apiandintegrations","articles":"articles","automatednotif":"automatednotif","careers":"careers","chef-gordon-ramsay-in-manila":"chef-gordon-ramsay-in-manila","dfesta":"dfesta","helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers":"helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers","helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success":"helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success","incomecalculator~spart":"incomecalculator~spart","incomecalculator":"incomecalculator","spart":"spart","pricing":"pricing","recurringpayments":"recurringpayments","revolutionizes-online-booking-for-visayas-largest-water-parks":"revolutionizes-online-booking-for-visayas-largest-water-parks","storefronts":"storefronts","surgeError":"surgeError","ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events":"ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events","up-sports-ticketing":"up-sports-ticketing","creators~ecommerce~services":"creators~ecommerce~services","creators":"creators","ecommerce":"ecommerce","services":"services","insights":"insights","privacyPolicy":"privacyPolicy","saas":"saas","termsAndConditions":"termsAndConditions","ticketing":"ticketing"}[chunkId]||chunkId) + "." + {"aboutUs":"4bec74dd","analytics~angwalangkwentangpodcast~apiandintegrations~articles~automatednotif~careers~chef-gordon-ra~4187b9c7":"1f1f57c6","analytics":"0b910129","angwalangkwentangpodcast":"783c5304","apiandintegrations":"228f5cf8","articles":"4fbbc3eb","automatednotif":"ca8cfded","careers":"a22a4f26","chef-gordon-ramsay-in-manila":"be6fd2c0","dfesta":"cb98c2b8","helix-pay-enhances-events-through-on-demand-id-badges-a-game-changer-for-organizers":"de7e13a7","helix-pay-partners-with-barefoot-theatre-collaborative-for-bar-boys-final-week-success":"1952f8bc","incomecalculator~spart":"64736d51","incomecalculator":"2844b8e8","spart":"bb3c9986","pricing":"8daf5390","recurringpayments":"6f7d8e07","revolutionizes-online-booking-for-visayas-largest-water-parks":"315b4a26","storefronts":"5cf6097e","surgeError":"74f6306b","ticketing-for-inclusivity-helixpays-support-of-lgbtqia-events":"ec72cfb9","up-sports-ticketing":"868c5c96","creators~ecommerce~services":"78fb75be","creators":"60779409","ecommerce":"220dee55","services":"aa2b97e7","insights":"9eeaf42e","privacyPolicy":"87686362","saas":"f954faa0","termsAndConditions":"b0ce6531","ticketing":"61eb4e52"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
